import styled from "@emotion/styled";

import { fontRoboto } from "shared/lib/styles";

import { BaseImage } from "scmp-app/components/common/base-image";
import PlayIcon from "scmp-app/components/video/video-play-icon/icon_play.svg";
import {
  playIconBackgroundHoverStyles,
  playIconBackgroundStyles,
} from "scmp-app/components/video/video-play-icon/styles";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  inline-size: 100%;
`;

export const ImageWrapper = styled.div`
  position: relative;

  inline-size: 100%;
`;

export const StyledImage = styled(BaseImage)`
  inline-size: 100%;
  block-size: auto;

  border-radius: 12px;

  object-fit: cover;

  aspect-ratio: 9/16;
`;

export const PlayIconWrapper = styled.div`
  position: absolute;
  inset-block-start: 12px;
  inset-inline-end: 12px;

  inline-size: 40px;
  block-size: 40px;
`;

export const StyledPlayIcon = styled(PlayIcon)`
  inline-size: 100%;
  block-size: 100%;

  ${playIconBackgroundStyles}

  ${Container}:hover & {
    ${playIconBackgroundHoverStyles}
  }
`;

export const Headline = styled.div`
  display: -webkit-box;

  max-block-size: 54.6px;

  color: #000000;
  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRoboto};
  font-style: normal;
  line-height: 130%;

  overflow: hidden;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
`;
